import script from "./ASBranchManageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ASBranchManageModal.vue?vue&type=script&setup=true&lang=js"

import "./ASBranchManageModal.vue?vue&type=style&index=0&id=5c615ace&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c615ace"]])

export default __exports__